<template>
  <div class="resetPassword">
    <div class="center">
      <h1>
        <span class="subtitle">{{ $t('schoolAccountResetPasswordPage.subtitle') }}</span><br />
        {{ $t('schoolAccountResetPasswordPage.title') }}
      </h1>
      <p v-html="$t('schoolAccountResetPasswordPage.description')"></p>
      <form @submit.prevent="submit">
        <div>
          <text-field class="input" type="email" :label="$t('schoolAccountResetPasswordPage.emailLabel')" v-model="username" />
        </div>
        <button-default :disable="!username || submitting">{{ $t('schoolAccountResetPasswordPage.submitButton') }}</button-default>
      </form>
      <div v-show="message" class="warning">{{ message }}</div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import { Auth } from "aws-amplify";
import TextField from "@/components/molecules/TextField.vue";
import ButtonDefault from "@/components/atoms/ButtonDefault.vue";

export default Vue.extend({
  // NOTE: metaタグの設定
  metaInfo: {
    meta: [
      {
        name: "robots",
        content: "none",
      },
    ],
  },
  components: { TextField, ButtonDefault },
  data() {
    return {
      username: "",
      message: "",
      submitting: false,
    };
  },
  methods: {
    async submit() {
      const { username } = this;

      try {
        this.submitting = true;
        await Auth.forgotPassword(username);
        this.$router.push({
          name: "resetPasswordSubmit",
          params: { username },
        });
      } catch (error: any) {
        this.submitting = false;
        console.error(error);
        if (error.code === "UserNotFoundException") {
          this.message = this.$t('schoolAccountResetPasswordPage.validation.userNotFound') as string;
        } else if (error.code === "LimitExceededException") {
          this.message = this.$t('schoolAccountResetPasswordPage.validation.limitExceeded') as string;
        } else {
          this.message = this.$t('schoolAccountResetPasswordPage.validation.genericError') as string;
        }
      }
    },
  },
});
</script>
<style lang="scss" scoped>
@import "@/style-common.scss";
.resetPassword {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;

  .center {
    font-size: var(--font-size-md);
    font-weight: var(--font-weight-bold);
    color: var(--color-text-normal);
    text-align: center;

    @include mq(sp) {
      margin: 50px 15px;
      padding: 0;
    }

    h1 {
      font-size: 1.5em;
      border-bottom: 3px solid var(--color-border);
      margin-bottom: 30px;
      color: var(--color-text-normal);

      @include mq(sp) {
        font-size: 1em;
      }

      .subtitle {
        font-size: 0.6em;

        @include mq(sp) {
          font-size: 0.8em;
        }
      }
    }

    p {
      font-size: var(--font-size-sm);
      color: var(--color-text-normal);
    }

    form {
      margin: 30px 0;
      font-size: 16.1px;

      @include mq(sp) {
        width: 100%;
      }

      button {
        padding: 10px 80px;
        border-radius: var(--radius-rounded);
        background-color: var(--color-primary);
        font-size: var(--font-size-md);
        color: var(--color-text-on-fixed-bg);
      }
    }
  }
}

.warning {
  border-radius: var(--radius-sm);
  padding: 20px;
  background-color: var(--color-surface-muted);
  border: 1px solid var(--color-warning);
  color: var(--color-warning);
}
</style>
